
// 支払通知書
$(() => {
    if (document.getElementById('agent-payment-form') != null) {
        $('.submission-exec').click(function(){
            $('#submission_comment').val($('#modal_submission_comment').val());
            $('#submission').submit();
        });

        $('.remand-exec').click(function(){
            $('#remand_comment').val($('#modal_remand_comment').val());
            $('#remand').submit();
        });

        $('#js-register-payment').click(function(){
            $('#register').submit();
        });
    }

});